import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import type {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import type {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {runInAction} from 'mobx';

export class CompetitorPlayerStatsModuleGoalViewHandler extends ActionHandler {
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.onGoalViewExpanded;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      const lastOutcome: Number = this.state.selectedPlayer?.selectedShot?.outcomeAnalyticValue;
      if(!this.state.selectedPlayer?.selectedShot && !params.isButtonClick && this.state.isShallowShotMap){
        this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {
          shot: this.state.selectedPlayer.selectedShotKey === null ? this.state.selectedPlayer.shots?.first() : null
        });
      }
      if (params.isButtonClick) {
        this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {
          shot: this.state.selectedPlayer.selectedShotKey === null ? this.state.selectedPlayer.shots?.first() : null
        });
        this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.shotMapShowMoreClick, {
          athleteId: this.state.selectedPlayer.athleteId,
          gameId: this.state.game.id,
          status: this.state.game.statusGroup,
          outcome: params.isVisible ? this.state.selectedPlayer?.selectedShot?.outcomeAnalyticValue : lastOutcome,
          clickType: params.isVisible ? COMPETITOR_PLAYER_STATS.SELECTOR_CLICK_TYPE.more : COMPETITOR_PLAYER_STATS.SELECTOR_CLICK_TYPE.less
        })
      }

      this.state.isGoalViewExpanded = params.isVisible || this.state.isShallowShotMap;
    })
  }
}
